/* tslint:disable */
/* eslint-disable */
export enum WorkStandardtaskResponsibleUsertypeEnum {
  Tpbuser = 'TPBUSER',
  User = 'USER',
  Electricianuser = 'ELECTRICIANUSER'
}
